<div class="breadcrumb mb-0 justify-content-between align-items-center">
  <p class="text-dark">
    <mat-icon>contact_support</mat-icon> Contact support: <a
      href="mailto:{{ supportEmail }}">{{ supportEmail }}</a>
  </p>
  <div class="text-dark d-flex align-items-end">
    <div class="ml-1"><small>By</small></div>
    <a href="https://www.irt-systemx.fr/" target="_blank"><img class="mx-1" src="../assets/images/systemx-logo.svg" height=30/></a>
  </div>
</div>